import React from 'react';
import { useDisclosure } from '@chakra-ui/react';
import { FormBlockContainerProps } from './formBlockProps';
import { ReportingContainerBaseConfig } from '../../base';
import { FormBlockController, FormBlockLoader } from './formBlockInterface';

export function createFormBlockContainer(
    config: ReportingContainerBaseConfig,
    loader: FormBlockLoader,
    controller: FormBlockController
): React.FC<FormBlockContainerProps> {
    const {
        kernel: {
            infra: {
                toaster: { useToast },
            },
        },
        context: { useContext },
    } = config;
    return ({ as: View, ...containerProps }) => {
        const context = {
            root: useContext(),
            block: config.infra.editor.context.useContext(),
        };
        const data = loader.useLoad(context.root, containerProps);
        const props = controller.useProps(context.root, data, {
            item: {
                adapter: context.block.adapter,
            },
            modal: {
                disclosure: useDisclosure(),
            },
        });
        return <View {...props} />;
    };
}
